import * as React from 'react';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import SportsIcon from '@mui/icons-material/Sports';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export const mainListItems = [
    {text: 'Home', icon: <HomeRoundedIcon/>, path: "/dashboard"},
    {text: 'Eleea', icon: <AccountCircleIcon/>, path: "/players/eleea-cairns/1111-1111-1111-1111"},
    {text: 'Teams', icon: <SportsIcon/>, path: "/teams"},
    {text: 'Players', icon: <SportsIcon/>, path: "/players"},
    {text: 'Analytics', icon: <AnalyticsRoundedIcon/>, path: "/analytics"},
    {text: 'Clients', icon: <PeopleRoundedIcon/>, path: "/clients"},
    {text: 'Tasks', icon: <AssignmentRoundedIcon/>, path: "/tasks"},
];

export const secondaryListItems = [
    {text: 'Settings', icon: <SettingsRoundedIcon/>, path: "/settings"},
    {text: 'About', icon: <InfoRoundedIcon/>, path: "/about"},
    {text: 'Feedback', icon: <HelpRoundedIcon/>, path: "/feedback"},
];
